export function normalizeString(str: string): string {
  // 转换为小写并去除首尾空格
  str = str.toLowerCase().trim()

  // 将空格、下划线、点号、斜杠统一转换为横杠
  str = str.replace(/[\s_./]+/g, "-")

  // 将多个连续的横杠替换为单个横杠
  str = str.replace(/-+/g, "-")

  // 去除首尾的横杠
  str = str.replace(/^-+|-+$/g, "")

  return str
}
export const getCurrentUrl = (headersList: Headers) => {
  const fullPath = headersList.get("x-full-path") || headersList.get("x-pathname") || "/"
  const protocol = headersList.get("x-forwarded-proto") || headersList.get("x-forwarded-protocol") || "https"
  const host = headersList.get("host") || ""
  return `${protocol}://${host}${fullPath}`
}
